import React from 'react'
import { Button, TableCardHeader } from 'react-md'

const ArtworkListActions = ({
  count,
  title,
  enableDelete,
  enablePublish,
  enableUnpublish,
  onDeleteClick,
  onPublishClick,
  onUnpublishClick,
  onRefreshClick
}) => {
  let actions = []

  if (enableDelete) {
    actions.push(
      <Button key='delete' icon onClick={onDeleteClick}>
        delete
      </Button>
    )
  }

  if (enableUnpublish) {
    actions.push(
      <Button key='unpublish' icon onClick={onUnpublishClick}>
        cloud_download
      </Button>
    )
  }

  if (enablePublish) {
    actions.push(
      <Button key='publish' icon onClick={onPublishClick}>
        cloud_done
      </Button>
    )
  }

  return (
    <TableCardHeader
      title={title}
      visible={count > 0}
      contextualTitle={`${count} item${count > 1 ? 's' : ''} selected`}
      actions={actions}
    >
      <Button icon onClick={onRefreshClick}>refresh</Button>
    </TableCardHeader>
  )
}

export default ArtworkListActions



// WEBPACK FOOTER //
// ./src/containers/Artworks/ArtworkListActions.js